import Link from 'next/link';
import styled from 'styled-components';

import { SearchBoxButton } from 'search/styles/SearchStyles';
import { t } from 'localization/utils/t';

const TP = 'error.components.notFoundCollections';

const COLLECTIONS = [
  { title: t(`${TP}.justDropped`, 'Just Dropped'), link: '/collections/just-dropped' },
  { title: t(`${TP}.goatSelects`, 'GOAT Selects'), link: '/collections/goat-selects-newest' },
  { title: t(`${TP}.mostWanted`, 'Most Wanted'), link: '/collections/most-wanted-new' },
  { title: t(`${TP}.newIn`, 'New In'), link: '/collections/new-arrivals-apparel' },
  { title: t(`${TP}.inSeason`, 'In Season'), link: '/collections/in-season' },
  {
    title: t(`${TP}.airJordan`, 'Air Jordan since 1985'),
    link: '/collections/air-jordan-since-1985',
  },
  { title: t(`${TP}.discoveryIndex`, 'Discovery Index'), link: '/collections/discovery-index' },
];

export const NotFoundCollections = ({ darkTheme }: { darkTheme?: boolean }) => {
  return (
    <NotFoundCollections.Wrapper>
      {COLLECTIONS.map((collection) => (
        <SearchBoxButton data-qa="suggested_search" key={collection.title} darkTheme={darkTheme}>
          <Link href={collection.link} passHref>
            <a>{collection.title}</a>
          </Link>
        </SearchBoxButton>
      ))}
    </NotFoundCollections.Wrapper>
  );
};

NotFoundCollections.Wrapper = styled.div`
  margin-bottom: 24px;
`;
